import useGetActorSummary from "../../../hooks/useGetActorSummary";
import { KeyValueList, NoData, RLCard } from "../../../../../components";
import AIGeneratedIcon from "../../../../../components/icons/AIGeneratedIcon";
import { ActorInsightsProps } from "../../../@types/actor";
import styles from "../ioc.module.scss";

const RelatedActors = ({ actorName }: ActorInsightsProps) => {
  const { data: actorData } = useGetActorSummary(actorName || "");
  const referencedActors = actorData?.referenced_actors || [];
  return (
    <RLCard
      header={
        <RLCard.Header>
          <div className="flex flex-center flex-gap-2">
            <span>Referenced Actors</span>
            <AIGeneratedIcon />
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          {referencedActors.length > 0 ? (
            <KeyValueList className={styles.ioc_key_value_entry}>
              {referencedActors.map(actor => (
                <KeyValueList.Item
                  key={actor.name}
                  label={`${actor.name}: `}
                  value={actor.reference_context || <NoData />}
                  className="overflow-ellipsis"
                />
              ))}
            </KeyValueList>
          ) : (
            <div>No known related actors.</div>
          )}
        </RLCard.Content>
      }
    />
  );
};

export default RelatedActors;
